// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e849b123","977":"f457ec47"}[chunkId] + ".chunk.js";
};